import ConfirmModal from '../UI/Modal/confirmModal';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { deleteRelease } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';

const DeleteReleaseModal = ({ setSelectedAction, selectedRelease, setSelectedRelease, getRelease }) => {
    const [loading, setLoading] = useState(false);
    const { userData } = useUserContext()

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await deleteRelease(userData?.token, selectedRelease._id, userData?.selectedOrganization?.org_token);
            if (res.status) {
                toast.success(res.message);
                getRelease();
                setSelectedRelease(null)
                setSelectedAction('');
            }
        } catch (error) {
            toast.error('Failed to delete the Release.');
            console.error('Delete Release error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfirmModal
            title="Delete Release"
            description="Are you sure you want to delete this Release?"
            ConfirmText="Delete"
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={handleDelete}
        />
    );
};

export default DeleteReleaseModal;
